// extracted by mini-css-extract-plugin
module.exports = {"container":"container-fY0FZ","label":"label-6A4Dx","input":"input-1prsc"};